import { IconButton } from "@mui/material";
import Grid from "@mui/material/Grid2";
import BootstrapTooltip from "../../../atoms/bootstrapTooltip/bootstrapTooltip";
import React from "react";
import ICoBrowseDto from "../../../../interface/ICoBrowseDto";
import { CoBrowseContext } from "../../../../store/coBrowse.context";
import FA__ClaptopSlashLightFull from "../../../../assets/icons/laptop-slash-light-full.svg";
import FA__ClaptopLightFull from "../../../../assets/icons/laptop-light-full.svg";
import SvgIcon from "../../../atoms/icons/svgIcon/svgIcon";

const CoBrowseButtons = (): React.JSX.Element => {
  const {
    coBrowseDto,
    cobrowseServiceStopSession,
    removeControl,
  }: {
    coBrowseDto: ICoBrowseDto;
    cobrowseServiceStopSession: () => void;
    removeControl: () => void;
  } = React.useContext(CoBrowseContext);

  return (
    <Grid
      size={8}
      sx={{
        display: "flex",
        justifyContent: "flex-end",
        gap: "10px",
      }}
    >
      <BootstrapTooltip title={"Bildschirmfreigabe beenden"} arrow>
        <IconButton
          aria-label="Bildschirmfreigabe beenden"
          onClick={cobrowseServiceStopSession}
        >
          <SvgIcon
            icon={FA__ClaptopSlashLightFull}
            color={(theme) => theme.palette.widgetStyles.navbar.chevronColor}
          />
        </IconButton>
      </BootstrapTooltip>

      <BootstrapTooltip title={"Kontrolle beenden"} arrow>
        <span>
          <IconButton
            aria-label="Kontrolle beenden"
            onClick={removeControl}
            disabled={!coBrowseDto.control.allowControl}
          >
            <SvgIcon
              icon={FA__ClaptopLightFull}
              color={(theme) => theme.palette.widgetStyles.navbar.chevronColor}
            />
          </IconButton>
        </span>
      </BootstrapTooltip>
    </Grid>
  );
};

export default CoBrowseButtons;
